<template>
  <Tooltip :title="tooltip">
    <div
      class="badge-availability-stock"
      :class="colorClass"
      @click="onBadgeClick(available)"
    >
      <span class="bas-text">{{ `${avail} ${available.unitOfMeasurementName || ""}`.trim() }}</span>
    </div>
  </Tooltip>
</template>

<script>
import Tooltip from "@nixweb/nixloc-ui/src/component/layout/Tooltip";

import { mapMutations } from "vuex";

export default {
  name: "BadgeAvailabilityStock",
  components: {
    Tooltip,
  },
  props: {
    itemRent: {
      type: Object,
      required: true,
    },
    available: {
      type: Object,
      default: () => ({
        date: "2025-10-11T15:34:00",
        productId: null,
        totalStock: 6,
        reserved: 1,
        rent: 1,
        maintenance: 0,
        available: 4,
        unitOfMeasurementName: "Pça",
      }),
    },
  },
  computed: {
    avail() {
      const v = Number(this.available?.available ?? 0);
      return Number.isNaN(v) ? 0 : v;
    },
    colorClass() {
      if (this.avail === 0) return "is-zero";
      if (this.avail > 0) return "is-positive";
      return "is-negative";
    },
    tooltip() {
      return `Disponível: ${this.avail} ${
        this.available?.unitOfMeasurementName || ""
      }`.trim();
    },
  },
  methods: {
    ...mapMutations("generic", ["addEvent"]),
    onBadgeClick(payload) {
      this.addEvent({
        name: "timeLineAvailability",
        data: { item: this.itemRent, showButtonBack: false },
      });
    },
  },
};
</script>

<style scoped>
.badge-availability-stock {
  display: inline-block;
  max-width: 10ch;
  padding: 4px 8px;
  border-radius: 10px;
  line-height: 1;
  font-weight: 500;
  user-select: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform 0.12s ease;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bas-text {
  font-size: 12px;
}

.is-zero {
  background: #f3f4f6;
  color: #6b7280;
  border-color: #e5e7eb;
}

.is-positive {
  background: #d1fae5;
  color: #065f46;
  border-color: #a7f3d0;
}

.is-negative {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}
</style>
